export default __webpack_public_path__ + "static/media/Marker.04ea3df9.svg";